/* Monogram overlay — Books Beyond Borders */
(function(){
  'use strict';

  var L = 0.700;
  var T = 0.52;

  var addonEl          = document.getElementById('monogram-addon');
  var ADDON_PRICE      = addonEl ? parseFloat(addonEl.dataset.addonPrice) || 2.50 : 2.50;
  var ADDON_VARIANT_ID = 49970300813549;

  var state = { text:'', active:false };
  var ov    = null;
  var rafH  = null;
  var basePriceEl=null, basePriceNode=null, basePriceText=null, basePrice=null;
  var pendingAddon = false;

  function init(){
    if(ov) return;
    var s = document.createElement('style');
    s.textContent = [
      '#mono-overlay {',
      '  font-family: "Times New Roman", Times, serif !important;',
      '  font-weight: normal !important;',
      '  font-size: 16px !important;',
      '  text-transform: uppercase !important;',
      '  letter-spacing: 0.20em !important;',
      '  white-space: nowrap;',
      '  color: rgba(0,0,0,0.50) !important;',
      '  text-shadow: 1.5px 1.5px 2px rgba(0,0,0,0.55),',
      '    -0.8px -0.8px 1px rgba(255,255,255,0.20) !important;',
      '  transform-origin: center center;',
      '}',
      '@media (max-width: 749px) {',
      '  #mono-overlay { font-size: 10px !important; letter-spacing: 0.15em !important; }',
      '}',
      'line-item[data-mono-locked] line-item-quantity { display: none !important; }'
    ].join('\n');
    document.head.appendChild(s);
    ov = document.createElement('span');
    ov.id = 'mono-overlay';
    ov.setAttribute('aria-hidden','true');
    ov.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;user-select:none;opacity:0;will-change:left,top;';
    document.body.appendChild(ov);
  }

  function getMainImg(){
    var imgs = document.querySelectorAll('.product-gallery img, .product-gallery__media img');
    var best = null, bestW = 0;
    imgs.forEach(function(img){
      var w = img.getBoundingClientRect().width;
      if(w > bestW){ bestW = w; best = img; }
    });
    return best;
  }

  function headerBottom(){
    var selectors = ['sticky-header','#shopify-section-header','.header-wrapper','.header','header'];
    var found = 0;
    for(var i=0;i<selectors.length;i++){
      var el = document.querySelector(selectors[i]);
      if(el){ var b=el.getBoundingClientRect().bottom; if(b>5){found=b;break;} }
    }
    return Math.max(found, 130);
  }

  function place(){
    if(!ov) return;
    if(!state.text||!state.active){ov.style.opacity='0';return;}
    var img=getMainImg();
    if(!img){ov.style.opacity='0';return;}
    var r=img.getBoundingClientRect();
    if(r.width===0||r.height===0||r.bottom<0||r.top>window.innerHeight){ov.style.opacity='0';return;}
    var tx=r.left+r.width*L;
    var ty=r.top+r.height*T;
    if(ty<headerBottom()){ov.style.opacity='0';return;}
    ov.style.left=Math.round(tx)+'px';
    ov.style.top=Math.round(ty)+'px';
    ov.style.transform='translate(-50%,-50%) rotate(90deg)';
    ov.style.opacity='1';
  }

  function startLoop(){
    if(rafH) return;
    (function loop(){
      place();
      rafH=(state.text&&state.active)?requestAnimationFrame(loop):null;
    })();
  }
  function stopLoop(){
    if(rafH){cancelAnimationFrame(rafH);rafH=null;}
    if(ov)ov.style.opacity='0';
  }

  function render(){
    init();
    var t=state.text.toUpperCase();
    ov.textContent=t;
    if(t&&state.active)startLoop();else stopLoop();
  }

  function setupPrice(){
    if(basePriceEl)return;
    basePriceEl=document.querySelector('.price-list--product sale-price');
    if(!basePriceEl)return;
    var nodes=basePriceEl.childNodes;
    for(var i=0;i<nodes.length;i++){
      if(nodes[i].nodeType===3&&nodes[i].textContent.trim()){
        basePriceNode=nodes[i];basePriceText=nodes[i].textContent;
        basePrice=parseFloat(basePriceText.replace(/[^\d.]/g,''));break;
      }
    }
  }
  function updatePrice(add){
    setupPrice();
    if(!basePriceNode||isNaN(basePrice))return;
    basePriceNode.textContent=basePriceText.replace(
      /[\d,]+\.?\d*/,(add?basePrice+ADDON_PRICE:basePrice).toFixed(2));
  }

  function openCartDrawer(){
    document.dispatchEvent(new CustomEvent('theme:open-cart', { bubbles: true }));
  }

  function refreshCartDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(!data['cart-drawer']) return;
        var f = new DOMParser().parseFromString(data['cart-drawer'],'text/html').querySelector('cart-drawer');
        if(f){ drawer.innerHTML = f.innerHTML; lockAddonLines(); }
      });
  }

  function cartChange(key, qty){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); });
  }

  function lockAddonLines(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer) return;
    drawer.querySelectorAll('line-item').forEach(function(li){
      var removeLink = li.querySelector('a[href*="/cart/change"]');
      if(!removeLink) return;
      var href = removeLink.getAttribute('href') || '';
      var idMatch = href.match(/[?&]id=([^&]+)/);
      if(!idMatch) return;
      var key = decodeURIComponent(idMatch[1]);
      if(key.indexOf(String(ADDON_VARIANT_ID)) === 0){
        li.setAttribute('data-mono-locked','');
      } else {
        li.removeAttribute('data-mono-locked');
      }
    });
  }

  function getAddonKeyFromDOM(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer) return null;
    var lineItems = drawer.querySelectorAll('line-item');
    for(var i=0;i<lineItems.length;i++){
      var a = lineItems[i].querySelector('a[href*="/cart/change"]');
      if(!a) continue;
      var href = a.getAttribute('href') || '';
      var idMatch = href.match(/[?&]id=([^&]+)/);
      if(!idMatch) continue;
      var key = decodeURIComponent(idMatch[1]);
      if(key.indexOf(String(ADDON_VARIANT_ID)) === 0) return key;
    }
    return null;
  }

  function hookCartRemovals(){
    document.addEventListener('click', function(e){
      var drawer = e.target.closest('cart-drawer');
      if(!drawer) return;

      if(e.target.closest('line-item[data-mono-locked]')){
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      var link = e.target.closest('a');
      if(!link) return;
      var href = link.getAttribute('href') || '';
      if(href.indexOf('/cart/change') === -1) return;

      var qtyMatch = href.match(/[?&]quantity=(\d+)/);
      if(!qtyMatch || parseInt(qtyMatch[1], 10) !== 0) return;

      var idMatch = href.match(/[?&]id=([^&]+)/);
      if(!idMatch) return;
      var lineKey = decodeURIComponent(idMatch[1]);
      var isAddon = lineKey.indexOf(String(ADDON_VARIANT_ID)) === 0;

      e.preventDefault();
      e.stopImmediatePropagation();

      if(isAddon){
        cartChange(lineKey, 0).then(function(){ refreshCartDrawer(); });
      } else {
        var addonKey = getAddonKeyFromDOM();
        if(addonKey){
          Promise.all([
            cartChange(lineKey, 0),
            cartChange(addonKey, 0)
          ]).then(function(){ refreshCartDrawer(); })
            .catch(function(){ refreshCartDrawer(); });
        } else {
          cartChange(lineKey, 0).then(function(){ refreshCartDrawer(); });
        }
      }
    }, true);
  }

  function hookAfterCartAdd(){
    var origFetch = window.fetch;
    window.fetch = function(url, opts){
      var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
      var isCartAdd = urlStr.indexOf('/cart/add.js') !== -1;
      var promise = origFetch.apply(this, arguments);

      if(isCartAdd && pendingAddon){
        var mono = pendingAddon;
        pendingAddon = false;
        promise.then(function(response){
          if(!response.ok) return;
          fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id: ADDON_VARIANT_ID, quantity: 1, properties: { 'Monogram Text': mono } })
          }).then(function(){ return refreshCartDrawer(); })
            .then(function(){ openCartDrawer(); })
            .catch(function(err){ console.error('BBB mono: addon add failed', err); });
        }).catch(function(){});
      }

      return promise;
    };
  }

  function hookCart(){
    document.addEventListener('click', function(e){
      if(!state.active || !state.text) return;
      var btn = e.target.closest('button[type="submit"], [type="submit"]');
      if(!btn || btn.closest('cart-drawer')) return;
      var form = btn.closest('form[action*="/cart/add"], product-form');
      if(!form) return;
      pendingAddon = state.text.toUpperCase();
    }, false);
  }

  var btnY    = document.getElementById('mono-btn-yes');
  var btnN    = document.getElementById('mono-btn-no');
  var monoForm= document.getElementById('mono-form');
  var inp     = document.getElementById('monogram-text-input');
  var cc      = document.getElementById('mono-char-count');
  var prop    = document.getElementById('mono-prop-input');
  if(!btnY||!inp)return;

  var MAX_WORDS = 3;
  var MAX_CHARS = 20;

  function enforceLimits(raw){
    var c = raw.replace(/[^A-Za-z .]/g,'');
    c = c.replace(/ {2,}/g,' ');

    var re = /\S+/g, m, wordCount = 0, cutIdx = -1;
    while((m = re.exec(c)) !== null){
      wordCount++;
      if(wordCount === MAX_WORDS){ cutIdx = m.index + m[0].length; }
      if(wordCount > MAX_WORDS){ c = c.slice(0, cutIdx); break; }
    }

    var nonSpace = 0, out = '';
    for(var i=0;i<c.length;i++){
      if(c[i] !== ' '){
        nonSpace++;
        if(nonSpace > MAX_CHARS) break;
      }
      out += c[i];
    }
    return out;
  }

  inp.addEventListener('input',function(){
    var c = enforceLimits(this.value);
    if(c !== this.value) this.value = c;
    state.text = c;
    var words = c.trim().length ? c.trim().split(/\s+/) : [];
    cc.textContent = words.length + ' / 3 words · ' + c.replace(/\s/g,'').length + ' / 20 chars';
    if(prop) prop.value = c.toUpperCase();
    render();
  });

  function setActive(y){
    state.active = y;
    if(y){
      btnY.classList.add('mono-toggle__btn--active');
      btnN.classList.remove('mono-toggle__btn--active');
      monoForm.classList.add('is-visible');
      inp.removeAttribute('disabled');
      updatePrice(true);
    } else {
      btnN.classList.add('mono-toggle__btn--active');
      btnY.classList.remove('mono-toggle__btn--active');
      monoForm.classList.remove('is-visible');
      inp.setAttribute('disabled','disabled');
      stopLoop();
      updatePrice(false);
    }
    render();
  }

  btnY.addEventListener('click', function(){ setActive(true); });
  btnN.addEventListener('click', function(){ setActive(false); });
  setActive(false);
  init();
  hookAfterCartAdd();
  hookCart();
  hookCartRemovals();

  document.addEventListener('cart-drawer:open', lockAddonLines);
  document.addEventListener('cart:updated', function(){ setTimeout(lockAddonLines, 400); });

}());
